import { colors } from 'components/styles/variables';
import EmailShareItem from './EmailShareItem';
import FacebookShareItem from './FacebookShareItem';
import TwitterShareItem from './TwitterShareItem';
import CopyLinkItem from './CopyLinkItem';

interface ShareDropdownProps {
  url: string;
  shareText: string;
  shareSubject: string;
  onEmailClick?: () => void;
  onFacebookClick?: () => void;
  onTwitterClick?: () => void;
  onCopyClick?: () => void;
}

const ShareDropdown = ({
  url,
  shareText,
  shareSubject,
  onEmailClick = (): void => {},
  onFacebookClick = (): void => {},
  onTwitterClick = (): void => {},
  onCopyClick = (): void => {},
}: ShareDropdownProps): JSX.Element => {
  return (
    <div className="share-dropdown">
      <EmailShareItem
        url={url}
        shareSubject={shareSubject}
        shareText={shareText}
        onClick={onEmailClick}
      />
      <FacebookShareItem url={url} onClick={onFacebookClick} />
      <TwitterShareItem url={url} shareText={shareText} onClick={onTwitterClick} />
      <CopyLinkItem onClick={onCopyClick} />
      <style jsx>{`
        .share-dropdown {
          z-index: 1;
          padding: 8px 0px;
          border-radius: 4px;
          border: 1px solid ${colors.G2};
          background-color: white;
          box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default ShareDropdown;
